import { ITrip } from "@cruisen/contract"
import { TripNavigatorState } from "../../../../models/RootStore.ts"
import { FilterType, SortType } from "../index"

export const filterTrips = (
  trips: ITrip[],
  filterType: FilterType,
  sortType: SortType,
  searchInput: string,
  navigatorStates: Map<string, TripNavigatorState>,
) => {
  return trips
    ?.sort((a, b) => {
      if (sortType === "priority") {
        return (
          (navigatorStates.get(b.id)?.lastMessageDate ?? b.twilioConversationLastMessageDate) -
          (navigatorStates.get(a.id)?.lastMessageDate ?? a.twilioConversationLastMessageDate)
        )
      } else {
        return Math.min(...a.months) - Math.min(...b.months)
      }
    })
    ?.filter((trip) => {
      if (filterType !== "all") {
        const isArchived = trip.tags?.includes("archived")
        if (filterType === "archived" && !isArchived) return false
        if (filterType === "open" && isArchived) return false
      }

      if (!searchInput) return true

      const searchTerm = searchInput.toLowerCase().trim()

      // Search by trip name
      if (trip.name.toLowerCase().includes(searchTerm)) return true

      // Search through collaborators
      return (
        trip.collaborators?.some((collaborator) => {
          // Search by full name
          const fullName = `${collaborator.firstName} ${collaborator.lastName}`.toLowerCase()
          if (fullName.includes(searchTerm)) return true

          // Search by email
          if (collaborator.email?.toLowerCase().includes(searchTerm)) return true

          return false
        }) ?? false
      )
    })
}
